function handleSwipe(element, { onSwipeRight, onSwipeLeft }) {
  element.addEventListener("touchstart", startTouch, false);
  element.addEventListener("touchmove", moveTouch, false);

  // Swipe Up / Down / Left / Right
  let initialX = null;
  let initialY = null;

  function startTouch(e) {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
  }

  function moveTouch(e) {
    if (initialX === null) return;
    if (initialY === null) return;
    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    const diffX = initialX - currentX;
    const diffY = initialY - currentY;
    if (Math.abs(diffX) > Math.abs(diffY)) {
      if (diffX > 0) {
        // swiped left
        e.preventDefault();
        onSwipeLeft();
      } else {
        // swiped right
        e.preventDefault();
        onSwipeRight();
      }
    } else {
      if (diffY > 0) {
        // swiped up
      } else {
        // swiped down
      }
    }
    initialX = null;
    initialY = null;
  }
}

if (!customElements.get("product-card")) {
  const isTouchDevice =
    "ontouchstart" in window ||
    navigator.MaxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;

  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this._elImageSlides = null;
      this._elCardSlides = null;
      this.dirty = false;
      this.element = this;

      this.handleSlide();
    }

    get elCardSlides() {
      if (!this._elCardSlides) {
        this._elCardSlides = this.querySelectorAll(".js-card-slide");
      }
      return this._elCardSlides;
    }

    handleSlide() {
      const elNextCardTrigger = this.querySelector(".js-card-next");
      if (elNextCardTrigger) {
        elNextCardTrigger.addEventListener("click", () => {
          this.dirty = true;
          plusSlides(this, 1);
        });
      }

      const elPrevCardTrigger = this.querySelector(".js-card-prev");
      if (elPrevCardTrigger) {
        elPrevCardTrigger.addEventListener("click", () => {
          this.dirty = true;
          plusSlides(this, -1);
        });
      }

      const elMediaContainer = this.querySelector(".c-product-card__media");
      if (elMediaContainer && this.elCardSlides.length > 1) {
        if (
          this.closest("collection-section") ||
          this.closest(".product-grid:not(.owl-carousel)")
        ) {
          handleSwipe(elMediaContainer, {
            onSwipeRight: () => plusSlides(this, -1),
            onSwipeLeft: () => plusSlides(this, 1),
          });
        }

        elMediaContainer.addEventListener("mouseenter", (e) => {
          if (this.dirty || isTouchDevice) return;
          plusSlides(this, 1);
        });

        elMediaContainer.addEventListener("mouseleave", (e) => {
          if (this.dirty || isTouchDevice) return;
          plusSlides(this, -1);
        });
      }
    }
  }

  customElements.define("product-card", ProductCard);
}

var slideIndexNumber = 1;

// Next/previous controls
function plusSlides(element, n) {
  let slideContainer = element.closest("product-card");
  let dots = slideContainer.querySelectorAll(".js-card-pagination");
  let slideNumber =
    Array.from(dots).findIndex((d) => d.classList.contains("is-active")) +
    1 +
    n;
  const totalSlides = slideContainer.elCardSlides.length;
  if (slideNumber > totalSlides) slideNumber = 1;
  else if (slideNumber < 1) slideNumber = totalSlides;
  showSlides(slideNumber, slideContainer, Math.sign(n));
}

// Thumbnail image controls
function currentSlide(element, n) {
  let slideContainer = element.parentElement.parentElement;
  showSlides((slideIndexNumber = n), slideContainer, 1);
}

function showSlides(n, slideContainer, direction) {
  slideContainer = slideContainer.closest("product-card");
  let i;
  let slides = slideContainer.elCardSlides;
  let dots = slideContainer.querySelectorAll(".js-card-pagination");

  if (n > slides.length) slideIndexNumber = 1;

  if (n < 1) slideIndexNumber = slides.length;

  for (i = 0; i < slides.length; i++) {
    slides[i].classList.remove("is-active");
  }

  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" is-active", "");
  }

  const nextActualSlide = slides[n - 1];

  preloadNextImage: {
    const elPreloadSlide = direction == 1
      ? slides[n % slides.length]
      : slides[n - 2 < 0 ? slides.length - 1 : n - 2];
    if (elPreloadSlide.querySelector(".lazyload")) {
      nextActualSlide.querySelector("img").addEventListener("load", () => {
        elPreloadSlide.querySelector(".lazyload").classList.add("lazypreload");
      }, { once: true });
    }
  }

  // fetchNextImageWithHighPriority
  nextActualSlide.querySelector(".lazyload")?.setAttribute("fetchpriority", "high");
  nextActualSlide.classList.add("is-active");
  dots[n - 1].className += " is-active";
}

function quickAddCart(e) {
  e.preventDefault();
  // window.location = jQ(this).attr('data-link');
  var jsonObj = [];

  var preOrder = "";
  if (
    $(this)
      .parents(".boost-pfs-filter-product-item")
      .eq(0)
      .find(".preorder_notification")
      .text() != ""
  ) {
    var preOrder = $(this)
      .parents(".boost-pfs-filter-product-item")
      .eq(0)
      .find(".preorder_notification")
      .text();
  }
  var $this = $(this);
  jsonObj.push({
    id: e.target.getAttribute("data-id"),
    quantity: 1,
    properties: {
      preOrder: preOrder,
    },
  });

  params = {
    type: "POST",
    url: ROUTES.cart.add + ".js",
    data: { items: jsonObj },
    dataType: "json",
    success: function (line_item) {
      ajaxCart.load();
      document.getElementById("basketToggle").click();
    },
    error: function (XMLHttpRequest, textStatus) {},
    complete: function (jqxhr, text) {},
  };
  jQuery.ajax(params);
}
